<div class="arbetsorder-search-filter-button">
    <ng-container button>
        <rask-button attr.color="{{getColor()}}" (click)="toggleShow()" aid="{{aid}}">{{title}}</rask-button>
    </ng-container>
</div>
<div [ngClass]="visible ? 'filter-visible container': 'filter-hidden'">
    <ng-content></ng-content>
</div>